module.exports = __webpack_public_path__ + "img/hi_viz.png";